import { instanceKey } from "../funnel/order";
import { publicKey } from "./registry";

/**
 * ═══ CE QU'UN VISITEUR NON CONNECTÉ A LE DROIT D'OUVRIR ═══
 *
 * « J'aimerais bien avoir un accueil public avec des sections publiques, on peut y
 * accéder pour les gens non connectés » (2026-08-20). Une page publique, c'est une
 * page qui PORTE LA CAPACITÉ (`SitePage.publishable`, voir le registre) et dont
 * l'organisateur a allumé l'interrupteur. Les deux, jamais l'une sans l'autre.
 *
 * ⚠️ LA GARDE RESTE CELLE DU CHÂSSIS, ce fichier ne fait que lui donner la clé à
 * lire. `needsSession` ne peut pas répondre : elle est pure, appelée depuis le
 * routeur, et la configuration arrive après lui.
 *
 * ⚠️ ET CE N'EST PAS UNE GARDE DE SÉCURITÉ. Rien de personnel ne transite par ces
 * écrans : ils ne lisent que la configuration de l'événement, que le serveur sert
 * déjà sans jeton (`GET /context/:alias`). Ouvrir la page n'ouvre aucune donnée que
 * l'adresse ne donnait pas déjà.
 */

/** L'accueil au registre des ÉCRANS. */
const HOME_SCREEN = "home";
/** L'accueil au registre des PAGES, celui du gestionnaire. */
const HOME_PAGE = "accueil";

/**
 * La clé « publique » de l'écran servi par cette adresse.
 *
 * ⚠️ L'ACCUEIL PORTE DEUX NOMS, et c'est le piège de cette fonction : `home` dans le
 * registre des écrans (`routes/registry.ts`, celui que `screenOf` interroge),
 * `accueil` dans celui des pages (`pages/registry.ts`, celui que le gestionnaire
 * affiche et qui écrit les réglages). Lue sous le mauvais nom, la clé n'existe pas,
 * donc l'accueil reste fermé quoi que l'organisateur clique — sans un mot.
 *
 * L'instance suffixe, comme partout : la section 2 peut être publique quand la 1 ne
 * l'est pas.
 */
export function publicKeyOfScreen(
  screenKey: string | undefined,
  instance?: string,
): string | undefined {
  if (!screenKey) return undefined;
  const page = screenKey === HOME_SCREEN ? HOME_PAGE : screenKey;
  return publicKey({ key: instanceKey(page, instance) });
}

/**
 * Cette adresse s'ouvre-t-elle sans session ? `read` est la lecture d'un réglage.
 *
 * ⚠️ STRICTEMENT `true`. Une clé absente, une chaîne « true » héritée, un zéro : tout
 * ce qui n'est pas le booléen vrai laisse la page fermée. C'est le sens de lecture
 * qu'on veut pour une porte — le doute la garde close.
 */
export function isPublicScreen(
  screenKey: string | undefined,
  instance: string | undefined,
  read: (key: string) => unknown,
): boolean {
  const key = publicKeyOfScreen(screenKey, instance);
  return !!key && read(key) === true;
}
